export class ProjectLight {
    id?: string;
    status?: string;
    pictureAccessLink?: string;
}
